import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ComponentBase, LocalStorage } from 't4core';
import { ChangePasswordBindingModel } from 't4core';




@Component({
  selector: 'dialog-changePassword',
  templateUrl: './changePassword.html',
  animations: [
      trigger('formStateBACKUP', [
          state('form', style({
              opacity: 1.0,
              display: 'block'
          })),
          state('successBACKUP', style({
              opacity: 0,
              display: 'none'
          })),
          transition('success => visible', animate('200ms ease-in')),
          transition('visible => success', animate('200ms ease-out'))
      ]),
      trigger('successStateBACKUP', [
          state('success', style({
              opacity: 1.0,
              display: 'block'
          })),
          state('form', style({
              opacity: 0,
              display: 'none'
          })),
          transition('success => form', animate('200ms ease-in')),
          transition('form => success', animate('200ms ease-out'))
      ])
  ]
})
export class ChangePasswordDialog extends ComponentBase {

    // <ViewModel>
    public isWorking: boolean = false;
    public state = "form";
    public validation: any = {
        passwordIncorrect: false
    };

    public theForm: FormGroup;
    // </ViewModel>

  constructor(
      public dialogRef: MatDialogRef<ChangePasswordDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private localStorage: LocalStorage
  ) {
      super();
      
      this.theForm = this.formBuilder.group({
          oldPassword: ['', Validators.required],
          newPassword: ['', Validators.required],
          confirmPass: ['', Validators.required]
      }, { validator: this.checkIfMatchingPasswords('newPassword', 'confirmPass') });
    }


    // <Validation>
    public checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
        return (group: FormGroup) => {
            let passwordInput = group.controls[passwordKey],
                passwordConfirmationInput = group.controls[passwordConfirmationKey];
            if (passwordInput.value !== passwordConfirmationInput.value) {
                return passwordConfirmationInput.setErrors({ notEquivalent: true })
            }
            else {
                return passwordConfirmationInput.setErrors(null);
            }
        }
     }
    // </Validation>

    // <Commands>
    public async changePassword() {
        if (this.theForm.invalid) return;
        this.isWorking = true;
        this.validation.passwordIncorrect = false;

        var data = new ChangePasswordBindingModel();
        data.OldPassword = this.theForm.get("oldPassword")!.value;
        data.NewPassword = this.theForm.get("newPassword")!.value;
        data.ConfirmPassword = this.theForm.get("confirmPass")!.value;
      try {
          var x = await this.Api.post("/Account/ChangePassword", data);

            this.state = "success";
            this.isWorking = false;

            // Update saved credentials
            var savedData = this.localStorage.getObject("AuthenticationData");
            if (savedData && savedData.password != undefined) {
                savedData.password = data.NewPassword;
                this.localStorage.setObject("AuthenticationData", savedData);
            }

            setTimeout(() => { this.dialogRef.close(); }, 3000);
        } catch (ex) {
            this.isWorking = false;
            this.validation.passwordIncorrect = true;
        }
    }
    // </Commands>

}
